<template>
    <div class="contact-item smooth-trans" @click="$emit('jump-to-profile',contact.uid)">
        <p class="unSelectable">{{contact.name}}</p>
    </div>
</template>
<script>
export default {
    name: 'contactItem',
    props:['contact']
}
</script>

<style>
.contact-item {
    height: 54px;
    margin-left: 12px;
    padding-left: 12px;
    margin-right: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    cursor: pointer;
}

.contact-item:hover {
    background-color: rgb(128,128,128,0.15);
}

.contact-item p{
    height: 35px; 
    line-height: 35px;
    font-size: 25px;
    overflow:hidden;  
    text-overflow: ellipsis;
}
</style>

